/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
import useAppStore from '../../store';

const getUserToken = () => {
  const zustandToken = useAppStore.getState().user_token;
  if (zustandToken) {
    return zustandToken;
  }
  const localStorageUserToken = localStorage.getItem('token');
  if (localStorageUserToken === 'undefined') {
    return null;
  }
  return localStorageUserToken;
};

export default getUserToken;
